import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { BETA_COPY, IS_BETA } from "@/lib/platformConfig";

interface BetaBadgeProps {
  className?: string;
}

/**
 * Compact browser-style BETA badge surfaced next to the logo in the
 * landing header. Returns null once `PLATFORM_PHASE` flips to "ga" so the
 * surface disappears cleanly at general availability.
 *
 * Visual style matches the QA Testing Toolkit reference (small uppercase
 * pill) but uses the brand TEAL token instead of sky so it stays on the
 * project's palette.
 */
export function BetaBadge({ className }: BetaBadgeProps) {
  if (!IS_BETA) return null;
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              "inline-flex items-center justify-center",
              "h-[18px] px-1.5 rounded-sm",
              "border border-primary/40 bg-primary/10 text-primary",
              "text-[9px] font-bold uppercase tracking-widest leading-none",
              "cursor-default select-none",
              className,
            )}
            aria-label="Beta"
          >
            {BETA_COPY.badge}
          </span>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="max-w-xs text-xs">
          {BETA_COPY.tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}